import { ICaptionsItem } from '../../types/common';

export const ADD_VIDEO = 'VIDEOS/ADD_VIDEO';
export const SET_VIDEO_CAPTIONS = 'VIDEOS/SET_VIDEO_CAPTIONS';
export const SET_VIDEO_CAPTIONS_EMPTY = 'VIDEOS/SET_VIDEO_CAPTIONS_EMPTY';

export interface IVideoItem {
  captions: Record<string, ICaptionsItem[]>;
  captionsEmpty: boolean;
}

export interface IVideosState extends IVideoItem {
}

export interface IAddVideoAction {
  type: typeof ADD_VIDEO;
  video: IVideoItem;
}

export interface ISetVideoCaptionsAction {
  type: typeof SET_VIDEO_CAPTIONS;
  code: string;
  captions: ICaptionsItem[];
}

export interface ISetVideoCaptionsEmptyAction {
  type: typeof SET_VIDEO_CAPTIONS_EMPTY;
  captionsEmpty: boolean;
}

export type IVideosActions =
  | IAddVideoAction
  | ISetVideoCaptionsAction
  | ISetVideoCaptionsEmptyAction
